//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            showHoverBg: false,
            itemOptions: {
                width: 587,
                height: 65
            },
            items: [{
                dropAreaIndex: 0,
                correctDropAreaIndex: 3,
                image: `/images/game/w4d1/team_green_${this.$lang.locale}.png`,
            }, {
                dropAreaIndex: 1,
                correctDropAreaIndex: 0,
                image: `/images/game/w4d1/team_lila_${this.$lang.locale}.png`,
            }, {
                dropAreaIndex: 2,
                correctDropAreaIndex: 4,
                image: `/images/game/w4d1/team_yellow_${this.$lang.locale}.png`,
            }, {
                dropAreaIndex: 3,
                correctDropAreaIndex: 2,
                image: `/images/game/w4d1/team_blue_${this.$lang.locale}.png`,
            }, {
                dropAreaIndex: 4,
                correctDropAreaIndex: 1,
                image: `/images/game/w4d1/team_red_${this.$lang.locale}.png`,
            }],
            dropAreas: [
                {
                    xMin: 143,
                    xMax: 730,
                    yMin: 248,
                    yMax: 313
                },
                {
                    xMin: 143,
                    xMax: 730,
                    yMin: 324,
                    yMax: 389
                },
                {
                    xMin: 143,
                    xMax: 730,
                    yMin: 399,
                    yMax: 464
                },
                {
                    xMin: 143,
                    xMax: 730,
                    yMin: 474,
                    yMax: 539
                },
                {
                    xMin: 143,
                    xMax: 730,
                    yMin: 549,
                    yMax: 614
                }
            ]
        };
    },

    computed: {
        result () {
            let numCorrect = this.items.filter(item => item.dropAreaIndex === item.correctDropAreaIndex).length;

            return this.$game.getDragDropResult(numCorrect, this.items.length - numCorrect);
        }
    },

    created () {
        this.items.forEach((item, index) => {
            this.$set(item, 'x', this.dropAreas[item.dropAreaIndex].xMin);
            this.$set(item, 'y', this.dropAreas[item.dropAreaIndex].yMin);
            this.$set(item, 'zIndex', 10);
        });
    },

    methods: {
        dragstart (item) {
            this.showHoverBg = true;
            item.zIndex++;
        },
        dragend (item, { x, y }) {
            this.showHoverBg = false;
            item.zIndex--;
            item.x = x;
            item.y = y;

            let dropAreaIndex = this.dropAreas.findIndex((area, index) =>
                x >= area.xMin - this.itemOptions.width &&
                x <= area.xMax &&
                y >= area.yMin - this.itemOptions.height &&
                y <= area.yMax
            );

            this.$nextTick(() => {
                if (dropAreaIndex === -1) {
                    item.x = this.dropAreas[item.dropAreaIndex].xMin;
                    item.y = this.dropAreas[item.dropAreaIndex].yMin;
                } else {
                    let dropAreaItem = this.items.find(item => item.dropAreaIndex === dropAreaIndex);

                    item.dropAreaIndex = dropAreaIndex;
                    item.x = this.dropAreas[dropAreaIndex].xMin;
                    item.y = this.dropAreas[dropAreaIndex].yMin;

                    if (dropAreaItem !== undefined) {
                        let newDropAreaIndex = this.dropAreas.findIndex((dropArea, index) => !this.items.some(item => item.dropAreaIndex === index));

                        if (newDropAreaIndex !== -1) {
                            dropAreaItem.dropAreaIndex = newDropAreaIndex;
                            dropAreaItem.x = this.dropAreas[newDropAreaIndex].xMin;
                            dropAreaItem.y = this.dropAreas[newDropAreaIndex].yMin;
                        }
                    }
                }
            });
        }
    }
};
